import { Box } from "@mui/material";
import { ReactNode } from "react";

import StyledLargeButton from "components/Styled/Button/StyledLargeButton";

interface Props {
  onBack: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
  nextLoading?: boolean;
  secondaryAction?: ReactNode;
}

export default function SourceStepFooter({
  onBack,
  onNext,
  nextDisabled,
  nextLoading,
  secondaryAction,
}: Props) {
  return (
    <Box
      sx={{
        mt: 2,
        pt: 2,
        borderTop: "1px solid",
        borderColor: "grey.200",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
      }}
    >
      <StyledLargeButton
        onClick={onBack}
        color="secondary"
        styles={{ px: { xs: 3, md: 5 } }}
      >
        <Box
          component="i"
          className="fa-regular fa-arrow-left"
          sx={{ mr: 1 }}
        />
        Back
      </StyledLargeButton>
      <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
        {secondaryAction}
      </Box>
      <StyledLargeButton
        color="primary"
        onClick={onNext}
        disabled={nextDisabled || !onNext}
        loading={nextLoading}
        styles={{ px: { xs: 3, md: 5 } }}
      >
        Next{" "}
        <Box
          component="i"
          className="fa-regular fa-arrow-circle-right"
          sx={{ ml: 1 }}
        />
      </StyledLargeButton>
    </Box>
  );
}
